export const GRAD_PLAN_MAPPING = {
  NON_TRANSFER: {
    ADVANCED_REGENTS_4_YEAR_MAR: {
      human: 'Advanced Regents 4 Year March',
      key: 'Advanced Regents 4 Year March',
      filterValue: 'Advanced Regents 4 Year March',
      order: 0,
    },
    ADVANCED_REGENTS_4_YEAR_JUNE: {
      human: 'Advanced Regents 4 Year June',
      key: 'Advanced Regents 4 Year June',
      filterValue: 'Advanced Regents 4 Year June',
      order: 1,
    },
    ADVANCED_REGENTS_4_YEAR_AUG: {
      human: 'Advanced Regents 4 Year Aug',
      key: 'Advanced Regents 4 Year Aug',
      filterValue: 'Advanced Regents 4 Year Aug',
      order: 2,
    },
    ADVANCED_REGENTS_5_YEAR: {
      human: 'Advanced Regents 5 Year',
      key: 'Advanced Regents 5 Year',
      filterValue: 'Advanced Regents 5 Year',
      order: 3,
    },
    ADVANCED_REGENTS_6_PLUS_YEAR: {
      human: 'Advanced Regents 6+ Year',
      key: 'Advanced Regents 6+ Year',
      filterValue: 'Advanced Regents 6+ Year',
      order: 4,
    },
    REGENTS_4_YEAR_MAR: {
      human: 'Regents 4 Year March',
      key: 'Regents 4 Year March',
      filterValue: 'Regents 4 Year March',
      order: 5,
    },
    REGENTS_4_YEAR_JUNE: {
      human: 'Regents 4 Year June',
      key: 'Regents 4 Year June',
      filterValue: 'Regents 4 Year June',
      order: 6,
    },
    REGENTS_4_YEAR_AUG: {
      human: 'Regents 4 Year Aug',
      key: 'Regents 4 Year Aug',
      filterValue: 'Regents 4 Year Aug',
      order: 7,
    },
    REGENTS_5_YEAR: {
      human: 'Regents 5 Year',
      key: 'Regents 5 Year',
      filterValue: 'Regents 5 Year',
      order: 8,
    },
    REGENTS_6_PLUS_YEAR: {
      human: 'Regents 6+ Year',
      key: 'Regents 6+ Year',
      filterValue: 'Regents 6+ Year',
      order: 9,
    },
    LOCAL_4_YEAR_MAR: {
      human: 'Local 4 Year March',
      key: 'Local 4 Year March',
      filterValue: 'Local 4 Year March',
      order: 10,
    },
    LOCAL_4_YEAR_JUNE: {
      human: 'Local 4 Year June',
      key: 'Local 4 Year June',
      filterValue: 'Local 4 Year June',
      order: 11,
    },
    LOCAL_4_YEAR_AUG: {
      human: 'Local 4 Year Aug',
      key: 'Local 4 Year Aug',
      filterValue: 'Local 4 Year Aug',
      order: 12,
    },
    LOCAL_5_YEAR: {
      human: 'Local 5 Year',
      key: 'Local 5 Year',
      filterValue: 'Local 5 Year',
      order: 13,
    },
    LOCAL_6_PLUS_YEAR: {
      human: 'Local 6+ Year',
      key: 'Local 6+ Year',
      filterValue: 'Local 6+ Year',
      order: 14,
    },
    PLAN_IN_PAST: {
      human: 'Plan in Past',
      key: 'Plan in Past',
      filterValue: 'Plan in Past',
      order: 15,
    },
    PLAN_INCOMPLETE: {
      human: 'Plan Incomplete',
      key: 'Plan Incomplete',
      filterValue: 'Plan Incomplete',
      order: 16,
    },
    GRADUATE: {
      human: 'Graduate',
      key: 'Graduate',
      filterValue: 'Graduate',
      order: 17,
    },
    NON_GRADUATE: {
      human: 'Non-Graduate',
      key: 'Non-Graduate',
      filterValue: 'Non-Graduate',
      order: 18,
    },
    NEGATIVE_DISCHARGE: {
      human: 'Negative Discharge',
      key: 'Negative Discharge',
      filterValue: 'Negative Discharge',
      order: 19,
    },
    NONE: {
      human: 'None',
      key: 'None',
      filterValue: 'None',
      order: 20,
    },
  },

  // TODO UPDATE AT TERM 1 FLIP: remove graduated cohort, add freshman cohort
  // Update order values
  TRANSFER: {
    // 2021
    ADVANCED_REGENTS_JAN_2021: {
      key: 'Advanced Regents Jan 2021',
      filterValue: 'Advanced Regents Jan 2021',
      order: 0,
    },
    ADVANCED_REGENTS_MARCH_2021: {
      key: 'Advanced Regents March 2021',
      filterValue: 'Advanced Regents March 2021',
      order: 1,
    },
    ADVANCED_REGENTS_JUNE_2021: {
      key: 'Advanced Regents June 2021',
      filterValue: 'Advanced Regents June 2021',
      order: 2,
    },
    ADVANCED_REGENTS_AUG_2021: {
      key: 'Advanced Regents Aug 2021',
      filterValue: 'Advanced Regents Aug 2021',
      order: 3,
    },
    // 2022
    ADVANCED_REGENTS_JAN_2022: {
      key: 'Advanced Regents Jan 2022',
      filterValue: 'Advanced Regents Jan 2022',
      order: 4,
    },
    ADVANCED_REGENTS_MARCH_2022: {
      key: 'Advanced Regents March 2022',
      filterValue: 'Advanced Regents March 2022',
      order: 5,
    },
    ADVANCED_REGENTS_JUNE_2022: {
      key: 'Advanced Regents June 2022',
      filterValue: 'Advanced Regents June 2022',
      order: 6,
    },
    ADVANCED_REGENTS_AUG_2022: {
      key: 'Advanced Regents Aug 2022',
      filterValue: 'Advanced Regents Aug 2022',
      order: 7,
    },
    // 2023
    ADVANCED_REGENTS_JAN_2023: {
      key: 'Advanced Regents Jan 2023',
      filterValue: 'Advanced Regents Jan 2023',
      order: 8,
    },
    ADVANCED_REGENTS_MARCH_2023: {
      key: 'Advanced Regents March 2023',
      filterValue: 'Advanced Regents March 2023',
      order: 9,
    },
    ADVANCED_REGENTS_JUNE_2023: {
      key: 'Advanced Regents June 2023',
      filterValue: 'Advanced Regents June 2023',
      order: 10,
    },
    ADVANCED_REGENTS_AUG_2023: {
      key: 'Advanced Regents Aug 2023',
      filterValue: 'Advanced Regents Aug 2023',
      order: 11,
    },
    // 2024
    ADVANCED_REGENTS_JAN_2024: {
      key: 'Advanced Regents Jan 2024',
      filterValue: 'Advanced Regents Jan 2024',
      order: 12,
    },
    ADVANCED_REGENTS_MARCH_2024: {
      key: 'Advanced Regents March 2024',
      filterValue: 'Advanced Regents March 2024',
      order: 13,
    },
    ADVANCED_REGENTS_JUNE_2024: {
      key: 'Advanced Regents June 2024',
      filterValue: 'Advanced Regents June 2024',
      order: 14,
    },
    ADVANCED_REGENTS_AUG_2024: {
      key: 'Advanced Regents Aug 2024',
      filterValue: 'Advanced Regents Aug 2024',
      order: 15,
    },
    // 2021
    REGENTS_JAN_2021: {
      key: 'Regents Jan 2021',
      filterValue: 'Regents Jan 2021',
      order: 16,
    },
    REGENTS_MARCH_2021: {
      key: 'Regents March 2021',
      filterValue: 'Regents March 2021',
      order: 17,
    },
    REGENTS_JUNE_2021: {
      key: 'Regents June 2021',
      filterValue: 'Regents June 2021',
      order: 18,
    },
    REGENTS_AUG_2021: {
      key: 'Regents Aug 2021',
      filterValue: 'Regents Aug 2021',
      order: 19,
    },
    // 2022
    REGENTS_JAN_2022: {
      key: 'Regents Jan 2022',
      filterValue: 'Regents Jan 2022',
      order: 20,
    },
    REGENTS_MARCH_2022: {
      key: 'Regents March 2022',
      filterValue: 'Regents March 2022',
      order: 21,
    },
    REGENTS_JUNE_2022: {
      key: 'Regents June 2022',
      filterValue: 'Regents June 2022',
      order: 22,
    },
    REGENTS_AUG_2022: {
      key: 'Regents Aug 2022',
      filterValue: 'Regents Aug 2022',
      order: 23,
    },
    // 2023
    REGENTS_JAN_2023: {
      key: 'Regents Jan 2023',
      filterValue: 'Regents Jan 2023',
      order: 24,
    },
    REGENTS_MARCH_2023: {
      key: 'Regents March 2023',
      filterValue: 'Regents March 2023',
      order: 25,
    },
    REGENTS_JUNE_2023: {
      key: 'Regents June 2023',
      filterValue: 'Regents June 2023',
      order: 26,
    },
    REGENTS_AUG_2023: {
      key: 'Regents Aug 2023',
      filterValue: 'Regents Aug 2023',
      order: 27,
    },
    // 2024
    REGENTS_JAN_2024: {
      key: 'Regents Jan 2024',
      filterValue: 'Regents Jan 2024',
      order: 28,
    },
    REGENTS_MARCH_2024: {
      order: 29,
      key: 'Regents March 2024',
      filterValue: 'Regents March 2024',
    },
    REGENTS_JUNE_2024: {
      key: 'Regents June 2024',
      filterValue: 'Regents June 2024',
      order: 30,
    },
    REGENTS_AUG_2024: {
      key: 'Regents Aug 2024',
      filterValue: 'Regents Aug 2024',
      order: 31,
    },
    // 2021
    LOCAL_JAN_2021: {
      key: 'Local Jan 2021',
      filterValue: 'Local Jan 2021',
      order: 32,
    },
    LOCAL_MARCH_2021: {
      key: 'Local March 2021',
      filterValue: 'Local March 2021',
      order: 33,
    },
    LOCAL_JUNE_2021: {
      key: 'Local June 2021',
      filterValue: 'Local June 2021',
      order: 34,
    },
    LOCAL_AUG_2021: {
      key: 'Local Aug 2021',
      filterValue: 'Local Aug 2021',
      order: 35,
    },
    // 2022
    LOCAL_JAN_2022: {
      key: 'Local Jan 2022',
      filterValue: 'Local Jan 2022',
      order: 36,
    },
    LOCAL_MARCH_2022: {
      key: 'Local March 2022',
      filterValue: 'Local March 2022',
      order: 37,
    },
    LOCAL_JUNE_2022: {
      key: 'Local June 2022',
      filterValue: 'Local June 2022',
      order: 38,
    },
    LOCAL_AUG_2022: {
      key: 'Local Aug 2022',
      filterValue: 'Local Aug 2022',
      order: 39,
    },
    // 2023
    LOCAL_JAN_2023: {
      key: 'Local Jan 2023',
      filterValue: 'Local Jan 2023',
      order: 40,
    },
    LOCAL_MARCH_2023: {
      key: 'Local March 2023',
      filterValue: 'Local March 2023',
      order: 41,
    },
    LOCAL_JUNE_2023: {
      key: 'Local June 2023',
      filterValue: 'Local June 2023',
      order: 42,
    },
    LOCAL_AUG_2023: {
      key: 'Local Aug 2023',
      filterValue: 'Local Aug 2023',
      order: 43,
    },
    // 2024
    LOCAL_JAN_2024: {
      key: 'Local Jan 2024',
      filterValue: 'Local Jan 2024',
      order: 44,
    },
    LOCAL_MARCH_2024: {
      key: 'Local March 2024',
      filterValue: 'Local March 2024',
      order: 45,
    },
    LOCAL_JUNE_2024: {
      key: 'Local June 2024',
      filterValue: 'Local June 2024',
      order: 46,
    },
    LOCAL_AUG_2024: {
      key: 'Local Aug 2024',
      filterValue: 'Local Aug 2024',
      order: 47,
    },
    PLAN_IN_PAST: {
      human: 'Plan in Past',
      key: 'Plan in Past',
      filterValue: 'Plan in Past',
      order: 48,
    },
    PLAN_INCOMPLETE: {
      human: 'Plan Incomplete',
      key: 'Plan Incomplete',
      filterValue: 'Plan Incomplete',
      order: 49,
    },
    GRADUATE: {
      human: 'Graduate',
      key: 'Graduate',
      filterValue: 'Graduate',
      order: 50,
    },
    NON_GRADUATE: {
      human: 'Non-Graduate',
      key: 'Non-Graduate',
      filterValue: 'Non-Graduate',
      order: 51,
    },
    NEGATIVE_DISCHARGE: {
      human: 'Negative Discharge',
      key: 'Negative Discharge',
      filterValue: 'Negative Discharge',
      order: 52,
    },
    NONE: {
      human: 'None',
      key: 'None',
      filterValue: 'None',
      order: 53,
    },
  },
};
